export const breakpoints = {
  original: 1920,
  desktop: 1280,
  tablet: 1024,
  mobile: 768
}
